export const localeCookie = 'sc-language';

export const defaultLocale = 'en-US';
